import React, { useEffect, useState } from "react";
import ReorderInventoryList from "./ReorderInventoryList";
import { Grid } from "@mui/material";
import SelectDropDown from "../../../reuseableComponents/SelectDropDown";
import InventoryTable from "../InventoryReport/InventoryTable";
import { generateCSVDataAndHeaders } from "../../../helperFunctions/csvHelper";
import { getCurrentDateRange } from "../../../helperFunctions/dataRange";
import DashDateRangeComponent from "../../../reuseableComponents/InventoryReportDateComponent";
import axios from "axios";
import { useSelector } from "react-redux";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import Config from "../../../Constants/Config";
import { el } from "date-fns/locale";
import { PERMISSIONS } from "../../../Constants/permission";

const HIDE_COST_COLUMN_IDS = [
  "gross_profit",
  "margin",
  "avg_cost",
  "inventory_cost",
  "cost_goods_sold",
];

const ReorderInventoryMain = ({ setCSVData, setCSVHeaders, setExportFilters, setExportAvailable, setExportHeaders }) => {
  const [selectedDateRange, setSelectedDateRange] = useState(
    getCurrentDateRange()
  );
  const { userTypeData, LoginGetDashBoardRecordJson } = useAuthDetails();
  const { permissions } = useSelector((state) => state.permissions);
  const hideCosts =
    Array.isArray(permissions) &&
    permissions.length > 0 &&
    permissions.includes(PERMISSIONS.HIDE_COST);

  const [hasMore, setHasMore] = useState(true);
  const [initialColumns, setInitialColumns] = useState([
    { id: "name", name: "Product Name" },
    { id: "plus_after_sku", name: "+" },
    { id: "closing_inventory", name: "Closing Inventory" },
    { id: "items_sold_per_day", name: "Items Sold per Day" },
    { id: "items_sold", name: "Items Sold" },
    { id: "inbound_inventory", name: "Inbound Inventory" },
    { id: "inventory_days_cover", name: "Days Cover" },
    { id: "avg_cost", name: "Average Cost" },
    { id: "plus_after_avg_cost", name: "+" },
  ]);
  const [reportType, setreportType] = useState([
    { id: "brand", name: "Brand" },
    { id: "vendor", name: "Vendor" },
    { id: "category", name: "Category" },
    { id: "tag", name: "Tag" },
  ]);
  const [loading, setLoading] = useState(false);
  const [allCloumns, setallColumns] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [selectedOrderSource, setSelectedOrderSource] = useState("Product");
  const [productListData, setProductListData] = useState([]);
  const [selectedOrderType, setSelectedOrderType] = useState("All inventory");
  const [totalRecords, setTotalRecords] = useState({});
  const [controller, setController] = useState();
  const [reorderTotal, setReorderTotal] = useState();
  const [selectedReportType, setSelectedReportType] = useState();
  const showcat = 0;
  // let controller = false;
  const reportTypeList = ["Product", "Brand", "Vendor", "Category"];
  // const reportTypeList = ["Product", "Brand", "Vendor"];
  const measureTypeList = [
    "On-hand-inventory",
    "Low inventory",
    "All inventory",
    "Out of stock",
  ];

  const applyHideCostColumns = (columns = []) =>
    hideCosts
      ? columns.filter((column) => !HIDE_COST_COLUMN_IDS.includes(column.id))
      : columns;

  const normalizeMeasureType = (val) => {
    if (!val) return val;
    const map = {
      "all inventory": "All inventory",
      "on-hand-inventory": "On-hand-inventory",
      "low inventory": "Low inventory",
      "out of stock": "Out of stock",
    };
    return map[String(val).toLowerCase()] || val;
  };
  const handleDateRangeChange = (dateRange) => {
    setProductListData([]);
    setTotalRecords({});
    setHasMore(true);
    setPage(1);
    setSelectedDateRange(dateRange);
    setTotalRecords({});
    if (typeof setExportAvailable === 'function') {
      // while loading, optimistically hide until we confirm data
      setExportAvailable(false);
    }
    if (typeof setExportFilters === 'function') {
      setExportFilters({
        start_date: dateRange?.start_date,
        end_date: dateRange?.end_date,
        search_by: dateRange?.search_by,
        measure_type: normalizeMeasureType(selectedOrderType),
        report_type: selectedOrderSource,
      });
    }
    getReportData(1, selectedOrderType, dateRange, selectedOrderSource);
    // fetchProductsData(1,selectedOrderType,dateRange,selectedOrderSource)
    // fetchRecordTotal(1,selectedOrderType,dateRange,selectedOrderSource)
  };

  const getReportData = async (
    page = 1,
    measureType = "All inventory",
    dateRange,
    reportType = "Product"
  ) => {
    fetchProductsData(page, measureType, dateRange, reportType);
    fetchRecordTotal(page, measureType, dateRange, reportType);
  };

  const createPayload = (
    pageNum = null,
    limit = null,
    measureType,
    dateRange,
    reportType
  ) => ({
    merchant_id: LoginGetDashBoardRecordJson?.data?.merchant_id,
    token_id: LoginGetDashBoardRecordJson?.token_id,
    login_type: LoginGetDashBoardRecordJson?.login_type,
    ...(pageNum !== null && { page: pageNum }),
    ...(limit !== null && { limit: limit }),
    start_date: dateRange.start_date,
    end_date: dateRange.end_date,
    measure_type: measureType,
    report_type: reportType,
    search_by: dateRange.search_by,
  });

  const fetchRecordTotal = async (
    page = 1,
    measureType = "All inventory",
    dateRange,
    reportType = "Product"
  ) => {
    if (reorderTotal) {
      // console.log("Aborting previous request...");
      reorderTotal.abort();
    }
    // Cancel previous request if it exists
    if (window.currentTotalCallSignal) {
      window.currentTotalCallSignal.abort();
    }

    let totalCallSignal = new AbortController();
    setReorderTotal(totalCallSignal);
    const payload = createPayload(0, 0, measureType, dateRange, reportType);
    // if (reportType == "Product") {
    let totalItemSoldUrl = `${Config.BASE_URL}${Config.ITEMS_SOLD_TOTAL}`;
    calculateTotal(
      payload,
      totalItemSoldUrl,
      "items_sold",
      totalCallSignal.signal
    );
    let totalClosingInventoryUrl = `${Config.BASE_URL}${Config.CLOSING_INVENTORY_TOTAL}`;
    calculateTotal(
      payload,
      totalClosingInventoryUrl,
      "closing_inventory",
      totalCallSignal.signal
    );
    let inBoundUrl = `${Config.BASE_URL}${Config.INBOUND_INVENTORY_TOTAL}`;
    calculateTotal(
      payload,
      inBoundUrl,
      "inbound_inventory",
      totalCallSignal.signal
    );
    if (allCloumns && allCloumns.length) {
      let arrayOfCals = [
        "net_sale",
        "gross_profit",
        "customer_count",
        "sale_count",
        "cost_goods_sold",
        "current_inventory",
        "retail_value",
        "return_count",
        "inventory_cost",
      ];
      for (let col of allCloumns) {
        if (arrayOfCals.indexOf(col.id) > -1) {
          let url = `${Config.BASE_URL}${Config.DYNAMIC_TOTAL_BASE}${col.id}_total`;
          calculateTotal(payload, url, col.id, totalCallSignal.signal);
        }
      }
    }
    // } else {
    //   calculateOldTotal(payload);
    // }
  };
  // all calculations
  const calculateTotal = async (payload, url, section, signal) => {
    // console.log("........total", payload);
    try {
      const response = await axios.post(`${url}`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
          // Authorization: `${LoginGetDashBoardRecordJson?.token}`,
          Authorization: `Bearer ${LoginGetDashBoardRecordJson?.token}`,
        },
        signal,
      });
      // console.log(response);
      if (!response.data[section]?.trim()?.length) {
        console.log("MisMatch Response");
      }
      if (response.data.status) {
        // if()
        // const newTotalRecords = { ...totalRecords };

        // Object.keys(response.data?.totals).forEach((key) => {
        //   if(response.data?.totals){
        //     // newTotalRecords[key] = response.data?.totals[key];
        //     totalRecords[key]= response.data?.totals[key];
        //   }
        // });
        totalRecords[section] = response.data[section];
        setTotalRecords(totalRecords);
        // console.log(totalRecords);
      } else {
        totalRecords[section] = response.data[section];
        setTotalRecords(totalRecords);
      }
    } catch (error) {
      // totalRecords[section] = 0;
      // setTotalRecords(totalRecords);
      console.error("Error fetching totals:", error);
    } finally {
    }
  };

  const calculateOldTotal = async (payload) => {
    if (reorderTotal) {
      // console.log("Aborting previous request...");
      reorderTotal.abort();
    }
    let totalCallSignal = new AbortController();
    setReorderTotal(totalCallSignal);
    try {
      // setLoading(true);
      const totalApiResponse = await axios.post(
        `${Config.BASE_URL}${Config.REORDER_TOTAL_LIST}`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            // Authorization: `${LoginGetDashBoardRecordJson?.token}`,
            Authorization: `Bearer ${LoginGetDashBoardRecordJson?.token}`,
          },
          signal: totalCallSignal.signal,
        }
      );

      if (totalApiResponse?.data.status) {
        const totalResponseData = totalApiResponse?.data?.totals;
        setTotalRecords(totalResponseData);
      } else {
        setTotalRecords("No Data Found");
      }
    } catch (error) {
      console.error("Error fetching totals:", error);
    } finally {
      // setLoading(false);
    }
  };
  const fetchProductsData = async (
    page = 1,
    measureType = "All inventory",
    dateRange,
    reportType = "Product"
  ) => {
    setIsLoading(true);
    if (typeof setExportFilters === 'function') {
      setExportFilters({
        start_date: (dateRange || selectedDateRange)?.start_date,
        end_date: (dateRange || selectedDateRange)?.end_date,
        search_by: (dateRange || selectedDateRange)?.search_by,
        measure_type: normalizeMeasureType(measureType),
        report_type: reportType,
      });
    }
    if (controller) {
      // console.log("Aborting previous request...");
      controller.abort();
    }
    let inventoryList = new AbortController();
    setController(inventoryList);
    try {
      const payload = createPayload(
        page,
        reportType == "Category" ? 6 : 12,
        measureType,
        dateRange,
        reportType
      );
      if (page == 1) {
        setLoading(true);
      }
      const response = await axios.post(
        // `${Config.BASE_URL}${Config.GET_REORDER_INVENTORY_LIST}`,Invenrory_report/Reorder_list
        `${Config.BASE_URL}${Config.GET_REORDER_INVENTORY_LIST}`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            // Authorization: `${LoginGetDashBoardRecordJson?.token}`,
            Authorization: `Bearer ${LoginGetDashBoardRecordJson?.token}`,
          },
          signal: inventoryList.signal,
        }
      );

      if (
        response?.data &&
        !response?.data?.status &&
        response?.data?.page == 1
      ) {
        setProductListData([]);
        setTotalRecords({});
        setLoading(false);
        if (typeof setExportAvailable === 'function' && page === 1) {
          setExportAvailable(false);
        }
      }
      if (response?.data && !response?.data?.status && response?.data.error) {
        setProductListData([]);
        setTotalRecords({});
        setLoading(false);
        if (typeof setExportAvailable === 'function' && page === 1) {
          setExportAvailable(false);
        }
      }

      const products = response?.data?.reorder_array;
      if (typeof setExportAvailable === 'function' && page === 1) {
        setExportAvailable(Array.isArray(products) && products.length > 0);
      }
      if (products && products.length < 5) {
        setHasMore(false);
      }
      if (products && products.length > 0 && page == 1) {
        setProductListData(products);
      } else if (products && products.length > 0 && page != 1) {
        setProductListData([...productListData, ...products]);
      }
      if (page > 1 && !products) {
        setHasMore(false);
      }
      setIsLoading(false);
      return products;
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      // setLoading(false);
    }
  };
  const fetchMoreData = () => {
    if (hasMore && productListData.length > 1) {
      setPage((prevPage) => prevPage + 1);
      const prevPage = page + 1;
      fetchProductsData(
        prevPage,
        selectedOrderType,
        selectedDateRange,
        selectedOrderSource
      );
    }
  };
  const handleOptionClick = (option, dropdown) => {
    setSelectedReportType(option);
    setPage(1);
    setHasMore(true);
    setProductListData([]);
    setTotalRecords({});
    switch (dropdown) {
      case "orderSource":
        setInitialColumns((prevColumns) => {
          let updatedColumns = [...prevColumns];
          if (option.title === "Product") {
            updatedColumns[0] = { id: "name", name: "Product Name" };
            if (
              !updatedColumns.some((column) => column.id === "plus_after_sku")
            ) {
              updatedColumns.splice(1, 0, { id: "plus_after_sku", name: "+" });
            }
          } else {
            updatedColumns[0] = {
              id: option.title.toLowerCase(),
              name: option.title,
            };

            updatedColumns = updatedColumns.filter(
              (item) => item.id !== "plus_after_sku"
            );
          }
          const dataArray = [
            { id: "brand", name: "Brand" },
            { id: "vendor", name: "Vendor" },
            { id: "category", name: "Category" },
            { id: "tag", name: "Tag" },
          ];
          setreportType((prevReportType) => {
            const lowerCaseTitle = option.title.toLowerCase();
            if (lowerCaseTitle === "brand" || lowerCaseTitle === "vendor") {
              return dataArray.filter(
                (item) => !["category", "tag", lowerCaseTitle].includes(item.id)
              );
            }
            return dataArray.filter((item) => item.id !== lowerCaseTitle);
          });
          return updatedColumns;
        });

        setSelectedOrderSource(option.title);
        if (typeof setExportAvailable === 'function') {
          setExportAvailable(false);
        }
        if (typeof setExportFilters === 'function') {
          setExportFilters({
            start_date: selectedDateRange?.start_date,
            end_date: selectedDateRange?.end_date,
            search_by: selectedDateRange?.search_by,
            measure_type: normalizeMeasureType(selectedOrderType),
            report_type: option.title,
          });
        }
        fetchProductsData(
          1,
          selectedOrderType,
          selectedDateRange,
          option.title
        );
        fetchRecordTotal(1, selectedOrderType, selectedDateRange, option.title);
        break;
      case "orderType":
        // setProductListData([])
        setSelectedOrderType(option.title);
        if (typeof setExportAvailable === 'function') {
          setExportAvailable(false);
        }
        if (typeof setExportFilters === 'function') {
          setExportFilters({
            start_date: selectedDateRange?.start_date,
            end_date: selectedDateRange?.end_date,
            search_by: selectedDateRange?.search_by,
            measure_type: normalizeMeasureType(option.title),
            report_type: selectedOrderSource,
          });
        }
        fetchProductsData(
          1,
          option.title,
          selectedDateRange,
          selectedOrderSource
        );
        fetchRecordTotal(
          1,
          option.title,
          selectedDateRange,
          selectedOrderSource
        );

        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setSelectedOrderType("All inventory");
    // fetchRecordTotal(1,"All inventory",selectedDateRange,"Product")
    // fetchProductsData(1,"All inventory",selectedDateRange, "Product");
  }, [setCSVData, setCSVHeaders]);

  useEffect(() => {
    const selectedCols = allCloumns && allCloumns.length ? allCloumns : initialColumns;
    const filteredData = applyHideCostColumns(selectedCols).filter(
      (item) =>
        item.id !== "plus_after_sku" && item.id !== "plus_after_avg_cost"
    );

    const { CSVData, CSVHeaders } = generateCSVDataAndHeaders(
      productListData,
      filteredData
    );
    setCSVData(CSVData);
    setCSVHeaders(CSVHeaders);
    if (typeof setExportHeaders === 'function') {
      try {
        setExportHeaders(filteredData.map((c) => c.name));
      } catch (e) {
        // no-op
      }
    }
  }, [productListData, initialColumns, allCloumns, hideCosts]);

  const handleUpdatedColumns = (updatedColumns) => {
    const filteredData = applyHideCostColumns(updatedColumns).filter(
      (item) =>
        item.id !== "plus_after_sku" && item.id !== "plus_after_avg_cost"
    );

    setallColumns(filteredData);
    // selectedOrderType, selectedOrderType, option.title
    const payload = createPayload(
      0,
      0,
      selectedOrderType,
      selectedDateRange,
      selectedOrderSource
    );
    // console.log(
    //   "selectedOrderType",
    //   selectedOrderType,
    //   " selectedOrderSource ",
    //   selectedOrderSource
    // );
    // console.log("reportType", reportType);
    if (
      // selectedOrderSource == "Product" &&
      filteredData &&
      filteredData.length
    ) {
      let arrayOfCals = [
        "net_sale",
        "gross_profit",
        "customer_count",
        "sale_count",
        "cost_goods_sold",
        "current_inventory",
        "retail_value",
        "return_count",
        "inventory_cost",
      ];
      for (let col of filteredData) {
        if (arrayOfCals.indexOf(col.id) > -1) {
          let url = `${Config.BASE_URL}${Config.DYNAMIC_TOTAL_BASE}${col.id}_total`;
          calculateTotal(payload, url, col.id);
          // 1
        }
      }
    }
    // let url ='test'
    // for(let i= 0; i< filteredData.length; i++){

    //   calculateTotal(payload,url,filteredData[i].id )
    // }
    const { CSVData, CSVHeaders } = generateCSVDataAndHeaders(
      productListData,
      filteredData
    );

    setCSVData(CSVData);
    setCSVHeaders(CSVHeaders);
    if (typeof setExportHeaders === 'function') {
      try {
        setExportHeaders(filteredData.map((c) => c.name));
      } catch (e) {
        // no-op
      }
    }
  };

  return (
    <>
      <Grid container className="box_shadow_div">
        <Grid item xs={12}>
          <Grid container sx={{ px: 2.5, pt: 2.3 }}>
            <Grid item xs={12}>
              <div className="filter-heading">Filter By</div>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ px: 2.5, pb: 2.2 }}>
            <Grid item xs={12} sm={6} md={showcat != 0 ? 4 : 4}>
              <label className="q-details-page-label">Report Type</label>
              <SelectDropDown
                sx={{ pt: 0.5 }}
                listItem={reportTypeList.map((item) => ({ title: item }))}
                title={"title"}
                dropdownFor={"orderSource"}
                selectedOption={selectedOrderSource}
                onClickHandler={handleOptionClick}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={showcat != 0 ? 4 : 4}>
              <label className="q-details-page-label">Measure</label>
              <SelectDropDown
                sx={{ pt: 0.5 }}
                listItem={measureTypeList.map((item) => ({ title: item }))}
                title={"title"}
                dropdownFor={"orderType"}
                selectedOption={selectedOrderType}
                onClickHandler={handleOptionClick}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container sx={{}}>
        <DashDateRangeComponent
          onSelectedReportType={selectedReportType}
          onDateRangeChange={handleDateRangeChange}
        />
      </Grid>
      <InventoryTable
        initialColumns={applyHideCostColumns(initialColumns)}
        initialData={productListData}
        scrollForProduct={fetchMoreData}
        hasMore={hasMore}
        loading={loading}
        reportType={reportType}
        totalRecords={totalRecords}
        onColumnsUpdate={handleUpdatedColumns}
        isLoading={isLoading}
      />
    </>
  );
};

export default ReorderInventoryMain;